import { render, staticRenderFns } from "./upload-case.vue?vue&type=template&id=1064ccc2&scoped=true"
import script from "./upload-case.vue?vue&type=script&lang=js"
export * from "./upload-case.vue?vue&type=script&lang=js"
import style0 from "./upload-case.vue?vue&type=style&index=0&id=1064ccc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064ccc2",
  null
  
)

export default component.exports